import styled from "@emotion/styled";
import { Alert24Icon } from "@kaltura/ds-react-icons";
import { Typography } from "@kaltura/ds-react-components";

export const MessageContainer = styled("div")(({ theme }) => ({
    textAlign: "center",
}));

export const StyledIcon = styled(Alert24Icon)(({ theme }) => ({
    color: theme.palette.primary.main,
    width: 36,
    height: 36,
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
}));
